import type { PImage } from '../../engine/aliases'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { chessLayers } from './chessLayers-sidecar'
import type { IChessPiece } from './chessPieces'

export interface IChessTilemapPart {
  i: number
  j: number
  x: number
  y: number
  image1: PImage
  imageCanMove: PImage
  pieces: IChessPiece[]
}

export function create(
  i: number,
  j: number,
  x: number,
  y: number,
  odd: boolean,
): IChessTilemapPart {
  let image1 = spritesUtil.createImage(
    chessLayers.getLayers().board,
    sprites.chessBoardPart[0],
  )

  image1.tint = odd ? 0xf3ebd7 : 0xa37754
  image1.scale = 1

  let imageCanMove = spritesUtil.createImage(
    chessLayers.getLayers().board,
    sprites.chessCircleBlue[0],
  )
  imageCanMove.scale = 0.5
  imageCanMove.alpha = 1 // 0.75

  let obj: IChessTilemapPart = {
    i,
    j,
    x,
    y,
    image1,
    imageCanMove,
    pieces: [],
  }
  moveToXY(obj, x, y)
  return obj
}

export function moveToXY(obj: IChessTilemapPart, x: number, y: number) {
  obj.x = x
  obj.y = y
  obj.image1.x = x
  obj.image1.y = y
  obj.imageCanMove.x = x
  obj.imageCanMove.y = y
}

// export function setTile(obj: IChessTilemapPart, colorIdx: number) {
//   // TODO: ????
// }
